import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Detail_4({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);
  let hitRange = item.scale.ranges.find((range) => range.isHit === true);

  return (
    <Row className={"mb-3 mx-0"} style={{ marginBottom: "6px" }}>
      {!isSub && (
        <Row className={"justify-content-center mx-0"} style={{ fontSize: 22, fontWeight: 700 }}>
          {item.scopeName}
        </Row>
      )}

      <div className={"py-3    rounded-4"} style={{ backgroundColor: isSub ? "white" : "#0048aa" }}>
        <Row className={"mb-2"}>
          <Col className={"align-content-center"}>
            {isSub && <Row className={"detail-scope-name-blurred-wrap-up mb-2 px-3"}>{item.scopeName}</Row>}
            <Row style={{ color: !isSub ? "white" : "" }} className={"main-scope-name-detail-wrap-up-new px-3 pb-2"}>
              {item.name}
            </Row>
          </Col>
        </Row>
        <Row className={"justify-content-between"}>
          <Col xs={4} className={"_scale-detail-text-new-wrap-up"}>
            <div style={{ color: !isSub ? "white" : "" }} dangerouslySetInnerHTML={{ __html: item.lowSideText }}></div>
          </Col>

          <Col xs={4} className={"px-3"}>
            <Row
              className={"justify-content-between round-40px border border-2 px-2 mt-4"}
              style={{ borderColor: "#A6D1FF" }}
            >
              {item.scale.ranges.map((range, i) => {
                const isLast = item.scale.ranges.length - 1 === i;
                const isFirst = i === 0;

                let margins = {
                  cubeMargin: "0%",
                  textMargin: "50%",
                };
                if (isFirst) {
                  margins.cubeMargin = "-25%";
                  margins.textMargin = "75%";
                }
                if (isLast) {
                  margins.cubeMargin = "25%";
                  margins.textMargin = "25%";
                }

                if (range.isHit === true) {
                  return (
                    <Col key={i} xs={"auto"} className={"align-content-center position-relative"}>
                      <Row className={"justify-content-center"}>
                        <Col className={"p-0"} style={{ width: "36px" }}>
                          <Row
                            className={"position-absolute translate-middle-x mx-0"}
                            style={{ top: "-25px", left: "50%" }}
                          >
                            <Col
                              xs={"auto"}
                              className={"position-relative px-0"}
                              style={{ marginLeft: margins.textMargin }}
                            >
                              <div
                                className={" z-0  rotated-div-cube  "}
                                style={{
                                  marginTop: 6,
                                  height: 15,
                                  width: 15,
                                  marginLeft: margins.cubeMargin,
                                  backgroundColor: isSub ? "#007aff" : "#fff5ce",
                                }}
                              ></div>
                              <div
                                className={
                                  " z-1 px-2 detail-hit-range-name-above-wrap-up translate-middle-x text-nowrap"
                                }
                                style={{
                                  marginTop: -30,

                                  backgroundColor: isSub ? "#007aff" : "#fff5ce",
                                  color: isSub ? "white" : "#00428a",
                                }}
                              >
                                {range.text}
                              </div>
                            </Col>
                          </Row>
                          <Row
                            className={"hit-scale-style-variable-opacity-wrap-up-round-smaller _flex-center  "}
                            style={{ margin: "2px -5px" }}
                          >
                            {elementScore}
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  );
                } else {
                  return (
                    <Col key={i} xs={"auto"} className={"align-content-center p-0"}>
                      <div
                        style={{
                          backgroundColor: "white",
                          width: "fit-content",
                          height: "fit-content",
                          borderRadius: "50%",
                          padding: 0,
                        }}
                      >
                        <div
                          className={"scale-style-variable-opacity-wrap-up-round-smaller"}
                          style={{ opacity: (i + 1) * (1 / item.scale.ranges.length) }}
                        ></div>
                      </div>
                    </Col>
                  );
                }
              })}
            </Row>
          </Col>

          <Col xs={4} className={"_scale-detail-text-new-wrap-up text-end"}>
            <div style={{ color: !isSub ? "white" : "" }} dangerouslySetInnerHTML={{ __html: item.highSideText }}></div>
          </Col>
        </Row>
      </div>
    </Row>
  );
}
